module.exports = __webpack_public_path__ + "img/arrowOrange.94cb443a.svg";